<template>
  <div>
    <aw-dropdown 
      class="dropdown" 
      placement="bottom-end" 
      :offset="[0, 6]"
      :dropdown-has-parent="dropdownHasParent"
    >
      <template v-slot:btn="{ open }">
        <div class="InputGroupFocus relative">
          <!-- real input, later will be invisible -->
          <input
            type="hidden"
            :name="name"
            :value="dateFormated"
            :class="inputClass"
            ref="fakeInput"
          />
          <!-- fake calendar -->
          <span 
            v-if="showFilterDropdown && (name === 'date_from' || name === 'created_from')" 
            class="absolute w-10 text-gray-500 pointer-events-none left-3"
          >
            {{$t('from')}}:
          </span>
          <span 
            v-if="showFilterDropdown && (name === 'date_to' || name === 'created_to')" 
            class="absolute w-10 text-gray-500 pointer-events-none left-3"
          >
            {{$t('to')}}:
          </span>
          <input
            v-model="dateHuman"
            type="text"
            class="form-control !pl-9"
            :class="{'text-right': showFilterDropdown && (name === 'date_from' || name === 'created_from' || name === 'date_to' || name === 'created_to')}"
            :id="id"
            :required="required"
            :data-nette-rules="dataNetteRules"
            :data-lfv-message-id="id + '_message'"
            @focus="openCalendar($event, open)"
            @click="openCalendar($event, open)"
            @blur="blurDate($event)"
          />
          <aw-icon
            icon="calendar"
            class="h-5 w-5 text-gray-400 absolute ml-2"
            :class="this.required?'top-0 mt-2':'top-1/2 -mt-2.5'"
          />
        </div>
      </template>

      <template v-slot:dropdown="{ opened, dropdown }">
        <div
          class="Dropdown Dropdown--Calendar Dropdown--SuperShadow absolute rounded-md bg-white max-w-xs text-sm top-full right-0  z-10"
          v-show="opened"
          :ref="dropdown"
        >
          <popup-calendar v-model="date"></popup-calendar>
        </div>
      </template>
    </aw-dropdown>

    <!-- <div class="form-control-plaintext">{{ dateHuman }} datummmmmm</div> -->
  </div>
</template>

<script>
import InputMixin from 'nette-back-module/js/mixins/input'
import formatDate from 'nette-base-module/js/utils/formatDate'
import parseDate from 'nette-base-module/js/utils/parseDate'
import date from 'locutus/php/datetime/date'

export default {
  mixins: [InputMixin],
  props: [
    'name',
    'id',
    'required',
    'dataNetteRules',
    'type',
    'disabled',
    'placeholder',
    'value',
    'inputClass',
    'showFilterDropdown',
    'dropdownHasParent'
  ],
  data() {
    return {
      selectedDate: null,
    }
  },
  computed: {
    date: {
      get() {
        return this.$controls[this.$props.id].val !== ''
          ? new Date(this.$controls[this.$props.id].val)
          : new Date()
      },
      set(val) {
        this.$store.dispatch('nette/updateControl', {
          controlName: this.$props.id,
          data: date('c', val),
          key: 'val'
        })

        this.$nextTick(() => {
          const e = new Event('change', { bubbles: true })
          const element = this.$refs.fakeInput
          element.dispatchEvent(e)
        })
      }
    },
    dateHuman: {
      get() {
        const val = this.$controls[this.$props.id].val
        if (val) {
          return formatDate(val, 'j.n.Y')
        }
        return ''
      },
      set(val) {
        const newDate = parseDate(val, 'dd.mm.yyyy')
        if (newDate) {
          this.$store.dispatch('nette/updateControl', {
            controlName: this.$props.id,
            data: date('c', newDate),
            key: 'val'
          })

          this.$nextTick(() => {
            const e = new Event('change', { bubbles: true })
            const element = this.$refs.fakeInput
            element.dispatchEvent(e)
          })
        }
      }
    },
    dateFormated() {
      const val = this.$controls[this.$props.id].val
      if (val) {
        return formatDate(val, 'Y-m-d')
      }
      return ''
    },
  },
  methods: {
    openCalendar(event, open) {
      this.blurDate(event)
      open()
    },
    blurDate(event) {
      const newDate = parseDate(event.target.value, 'dd.mm.yyyy')
      if (newDate === false) {
        this.$store.dispatch('nette/updateControl', {
          controlName: this.$props.id,
          data: this.$controls[this.$props.id].val,
          key: 'val'
        })
      } else if (newDate === null) {
        this.$store.dispatch('nette/updateControl', {
          controlName: this.$props.id,
          data: '',
          key: 'val'
        })
      } else {
        this.$store.dispatch('nette/updateControl', {
          controlName: this.$props.id,
          data: date('c', newDate),
          key: 'val'
        })
      }
    }
  }
}
</script>
